import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import FilterForm from "./FilterForm";
import ContentForm from "./ContentForm";

const useStyles = makeStyles(() => ({
  filterContainer: {
    position: "relative",
  },
  emailContainer: {
    position: "relative",
    marginTop: 32,
  },
}));

const BroadcastForm: FC<any> = ({ handleSubmit }) => {
  const classes = useStyles();

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className={classes.filterContainer}>
        <FilterForm />
      </div>
      <div className={classes.emailContainer}>
        <ContentForm />
      </div>
    </form>
  );
};

export default React.memo(BroadcastForm);
